import type { ServerPaginationConfig } from '@shared/types/module-config';

export const PAYINS_PAGINATION: ServerPaginationConfig = {
  enabled: true,
  mode: 'server',
  pageParam: 'page',
  sizeParam: 'size',
  defaultSize: 25,
  firstPage: 1,
  sendPageIfDefault: true,
};

export const PAYOUTS_PAGINATION: ServerPaginationConfig = {
  enabled: true,
  mode: 'server',
  pageParam: 'page',
  sizeParam: 'size',
  defaultSize: 25,
  firstPage: 0,
  sendPageIfDefault: true,
};

export const FULL_GATEWAY_ROUTE_PATHS = {
  fullGateway: '/movements/full-gateway',
};

export const FULL_GATEWAY_API_PATHS = {
  payinList: '/v1/api/platform/gateway/payin-full-gateway',
  payinApprove: '/v1/api/platform/gateway',
  payinCancel: '/v1/api/platform/gateway',
  payinStatus: '/v1/api/platform/gateway/payin/status',
  payinApproveCsv: '/v1/api/platform/gateway/approve/csv',
  payinCancelCsv: '/v1/api/platform/gateway/cancel/csv',
  payoutList: '/v1/api/platform/gateway/payout/list',
  payoutCancelBatch: '/v1/api/platform/merchant/cancel/batch-cashout',
};

export const PAYINS_URL_FILTER_KEYS = ['payinId', 'originId', 'originUserId', 'gatewayId', 'cpf', 'pageSize', 'pageNumber'];

export const PAYOUTS_URL_FILTER_KEYS = ['payoutId', 'originId', 'originUserId', 'gatewayId', 'cpf', 'pageSize', 'pageNumber'];